import { render, staticRenderFns } from "./VerificationCode1.vue?vue&type=template&id=1fc60fa3&scoped=true&"
import script from "./VerificationCode1.vue?vue&type=script&lang=js&"
export * from "./VerificationCode1.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCode1.vue?vue&type=style&index=0&id=1fc60fa3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc60fa3",
  null
  
)

export default component.exports